// @ts-nocheck
import { Input } from "antd";
import Validation from "atoms/validation/validation";
import _ from "lodash";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import * as dynamicGridSagaActions from "../dynamicGrid/sagaActions";
import { RenderCell } from "./gridComponents";
import { getGridMetadata } from "models/dynamicGrid/selector";

const inputDOMMap = new Map<string, HTMLInputElement>();

const RenderInput = (props: any) => {
  const dispatch = useDispatch();
  const [debounce, updateDebounce] = React.useState(null);
  const {
    row,
    rowIdentifier,
    tableId,
    isPaginated,
    isUploadGrid,
    id,
    type = "number",
    isInlineEdit,
    align,
    params,
    isPivotMode,
  } = props;

  const gridMetaData = useSelector((state) => getGridMetadata(state, tableId));
  const value = row?.[rowIdentifier]?.hasOwnProperty("value")
    ? row?.[rowIdentifier]?.value
    : row?.[rowIdentifier];

  const [inputValue, updateInputValue] = React.useState(value);
  const ref = React.useCallback(
    (node: HTMLInputElement) => {
      const rowIndex = params.node?.rowIndex;
      const colId = params.column?.getColId?.();
      const key = `${rowIndex}|${colId}`;

      if (node) {
        inputDOMMap.set(key, { node, value }); // track input + its value
      } else {
        inputDOMMap.delete(key);
      }
    },
    [params, value]
  );

  React.useEffect(() => {
    updateInputValue(value);
  }, [value]);

  const dispatchUpdate = (newVal: any) => {
    const rowIndex = params.node?.rowIndex;
    const colId = params.column?.getColId?.();
    const key = `${rowIndex}|${colId}`;
    const entry = inputDOMMap.get(key);

    if (entry?.value === newVal) return; // already synced

    dispatch(
      dynamicGridSagaActions.updateRowData({
        tableId: Number(tableId),
        row,
        rowIdentifier,
        isUploadGrid,
        updatedValue: type === "number" ? Number(newVal) : newVal,
        isInlineEdit,
        isGroupNode: params?.node?.group,
        isPivotMode,
      })
    );

    // Update stored committed value
    if (entry) {
      inputDOMMap.set(key, { ...entry, value: newVal });
    }
  };

  const handleChange = (e) => {
    const parsedValue = e.target.value;
    e.stopPropagation();
    updateInputValue(parsedValue);
    clearTimeout(debounce);
    const debounceFn = setTimeout(
      () => {
        if (_.isEmpty(parsedValue)) return;
        dispatchUpdate(parsedValue);
      },
      isPaginated ? 1000 : 100
    );
    updateDebounce(debounceFn);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Tab") {
      e.preventDefault();
      clearTimeout(debounce); // cancel debounce
      dispatchUpdate(inputValue); // force flush

      const { api, column, node } = params;
      const rowIndex = node?.rowIndex;

      if (!api || !column || rowIndex == null) {
        console.warn("Missing api, column or rowIndex");
        return;
      }

      // Find next column
      const getFocusedCell = api.getFocusedCell();
      inputDOMMap
        .get(`${getFocusedCell.rowIndex}|${getFocusedCell.column.getColId()}`)
        ?.node?.focus();
    }
  };

  if (row?.IsParent === 0 || !row.hasOwnProperty(rowIdentifier)) {
    return (
      <RenderCell row={row} rowIdentifier={rowIdentifier} type={"number"} />
    );
  }

  const hasGridEditOperation =
    gridMetaData?.dataProviderOptions?.isGridEditDisabledOverride;
  const isLocked =
    row?.IsReadOnly ||
    row?.OrderStatusID === 2 ||
    hasGridEditOperation ||
    false;

  return (
    <div className="render-input-right">
      <Validation
        row={row}
        rowIdentifier={rowIdentifier}
        {...row[rowIdentifier]}
      >
        <Input
          ref={ref}
          type={type === "number" || type === "qty" ? "number" : "text"}
          min={tableId === 27 ? null : 0}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          placeholder=""
          value={inputValue}
          step={row["QtyPerShelf"] || row["OrderMultiple"]}
          disabled={isLocked}
        />
      </Validation>
    </div>
  );
};

export default RenderInput;
